// Scheduling
export const FETCH_TIMESLOTS = "FETCH_TIMESLOTS";
export const FETCH_LOCATIONS = "FETCH_LOCATIONS";
export const FETCH_PROVIDERS_IMAGE = "FETCH_PROVIDERS_IMAGE";
export const FETCH_PROVIDERS = "FETCH_PROVIDERS";
export const FETCH_TIME = "FETCH_TIME";
export const CREATE_APPOINTMENT = "CREATE_APPOINTMENT";
export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";
export const SET_TIMESLOT_LOCATION = "SET_TIMESLOT_LOCATION";
export const FETCH_TIMESLOTS_BOOLEAN = "FETCH_TIMESLOTS_BOOLEAN";
export const SELECTED_DATE = "SELECTED_DATE";
export const SELECTED_HOURS = "SELECTED_HOURS";
export const SET_GEOLOCATIONS = "SET_GEOLOCATIONS";
export const USER_OPENING_TIMESLOT = "USER_OPENING_TIMESLOT";
export const FETCH_FILTERED_PROVIDERS = "FETCH_FILTERED_PROVIDERS";
export const FILTERED_TIMESLOTS = "FILTERED_TIMESLOTS";
export const SET_TIMESLOT_LOCATION_NAME = "SET_TIMESLOT_LOCATION_NAME";
export const FETCH_TIMESLOTS_SOONEST = "FETCH_TIMESLOTS_SOONEST";
export const FETCH_TIMESLOTS_SOONEST_TRIGGER =
  "FETCH_TIMESLOTS_SOONEST_TRIGGER";
export const FETCH_TIMESLOTS_SOONEST_ADVANCED =
  "FETCH_TIMESLOTS_SOONEST_ADVANCED";
